import { useState } from "react";
import DropdownMenuDivider from "components/Menus/DropdownMenuDivider";
import DropdownOptionWithIcon from "components/Menus/DropdownOptionWithIcon";
import PopoverDropdownMenu from "components/Menus/PopoverDropdownMenu";

const LocationOptions = ({
  onModifyLocation,
  onRemoveLocation,
  onSetLocationAsPrimary,
  location,
}) => {
  const [copied, setCopied] = useState(false);

  return (
    <PopoverDropdownMenu>
      <h5
        style={{ maxWidth: 250 }}
        className="px-2 pt-2 text-dark text-truncate"
      >
        Location Options
      </h5>
      <DropdownMenuDivider></DropdownMenuDivider>
      <DropdownOptionWithIcon
        name={`${copied ? "Copied!" : "Copy to Clipboard"}`}
        icon="mdi mdi-dock-window"
        disabled={copied}
        onClick={() => {
          navigator.clipboard.writeText(location.Readable);
          setCopied(true);

          setTimeout(() => {
            setCopied(false);
          }, 1500);
        }}
      />
      <DropdownOptionWithIcon
        name="Open in Google Maps"
        icon="mdi mdi-map"
        onClick={() =>
          window.open(
            `https://www.google.com/maps/search/?api=1&query=${location.Readable}`,
            "_blank"
          )
        }
      />
      <DropdownOptionWithIcon
        name="Modify Location"
        icon="mdi mdi-pencil"
        onClick={onModifyLocation}
      />
      <DropdownOptionWithIcon
        name="Set Location as Primary"
        icon="mdi mdi-star"
        disabled={location?.Primary}
        onClick={onSetLocationAsPrimary}
      />

      <DropdownMenuDivider></DropdownMenuDivider>
      <DropdownOptionWithIcon
        name="Remove Location"
        icon="mdi mdi-delete"
        onClick={onRemoveLocation}
      />
    </PopoverDropdownMenu>
  );
};

export default LocationOptions;
